import { DependencyList, useEffect, useState } from "react";
import { useMounted } from "./useMounted";

export type UseLoadAction = (args?: any) => any;
export interface UseLoadAdditionalParams {
    reloadProperties?: DependencyList;
    isDataLoaded?: boolean;
    loadArgs?: any;
}

type UseLoadData = (loadAction: UseLoadAction, loadOptions?: UseLoadAdditionalParams) => boolean;
export const useLoadData: UseLoadData = (
    loadAction,
    { reloadProperties = [], isDataLoaded = false, loadArgs } = {}
) => {
    const [isLoading, setIsLoading] = useState(!isDataLoaded);
    const isMounted = useMounted();
    const resetLoading = () => {
        if (isMounted.current) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isDataLoaded) {
            return;
        }
        setIsLoading(true);
        loadAction(loadArgs).then(resetLoading, resetLoading);
    }, reloadProperties);

    return isLoading;
};
